module.exports = __webpack_public_path__ + "static/logo-7a07a170df53241923eda83ee6d20352.png";